/**
 * @group User
 * @summary Deletion request status values
 * 
 * <blockquote>
 * Defines the possible status values for data deletion requests.
 * Used both as TypeScript constants and as PostgreSQL enum values.
 * </blockquote>
 * 
 * Token Lifecycle:
 * - pending: Request created, awaiting email confirmation
 * - confirmed: User clicked confirmation link
 * - completed: Data successfully deleted
 * - expired: Token expired without confirmation (24h)
 */
export const DELETION_REQUEST_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
} as const;

